<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="슥삭" />
            <Navbar></Navbar>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container v-if="userinfo.authAdmin == 2" fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">피드 등록</span>
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">주 단위로 주기적으로 올립시다.(일주일 단위로 이번주 랭킹 조회를 위함)</span>
    
                                <v-text-field dense label="피드 제목" outlined hint="제목을 입력해주세요." class="mt-5 col-8" v-model="feedName" block></v-text-field>
                                <v-text-field dense label="공고 기관" outlined hint="공고 기관을 입력해주세요." class="mt-1 col-8" v-model="feedHost" block></v-text-field>
                                <v-text-field dense label="피드 주소" outlined hint="피드 주소를 입력해주세요." class="mt-1 col-8" v-model="feedUrl" block></v-text-field>
                                <!-- <v-text-field label="피드 미리보기 이미지 주소" outlined hint="주소를 입력해주세요." class="mt-2 col-8" v-model="feedPreviewImgUrl" block></v-text-field> -->
    
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1 mt-1">피드 이미지를 업로드 해주세요.</span>
                                <v-file-input dense accept="image/*" label="File input" class="mt-2 col-8" v-model="file" outlined></v-file-input>
                                <v-btn v-if="!isUploaded" class="ml-2 mt-2 bg-main-dark text-white" v-on:click="upload()">이미지 업로드</v-btn>
                                <v-btn v-else class="ml-2 mt-2 bg-main-dark-opac-15 text-main" outlined v-on:click="uploadInit()">이미지 초기화</v-btn>
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1 mt-1">피드 분야를 선택해주세요.</span>
                                <v-btn :class="categoryIdx == 101 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 101">대학생활</v-btn>
                                <v-btn :class="categoryIdx == 102 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 102">취업뉴스</v-btn>
                                <v-btn :class="categoryIdx == 103 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 103">시사상식</v-btn>
                                <v-btn :class="categoryIdx == 104 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 104">금융상식</v-btn>
                                <v-btn :class="categoryIdx == 105 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 105">디자인</v-btn>
                                <v-btn :class="categoryIdx == 106 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 106">기타</v-btn>
    
                            </v-row>

                            <v-row>
                                <v-col cols="4" class="ml-0 mr-auto">
                                    <v-btn class="bg-main-dark text-white border-main-rounded5 rem-1_2" block :height="60" outlined v-on:click="registerFeed">피드 등록</v-btn>
                                </v-col>
                            </v-row>

    
                            <div style="height:100px;"></div>
    
                            <v-row>
                                <span class="col-12 rem-2 text-left">피드 조회</span>
                            </v-row>
                            <v-row class="mt-2">
                                <v-tabs v-model="tab" background-color="primary" dark>
                                    <v-tab v-for="item in items" :key="item.tab" v-on:click="goCategory(item.href)">
                                        {{ item.tab }}
                                    </v-tab>
                                </v-tabs>
                            </v-row>
    
                            <!-- <v-row class="">
                                            <v-text-field label="검색어" height="40" outlined hint="검색어를 입력해주세요." class="ml-auto mr-0 col-xs-6 col-sm-4 mt-1" v-model="query" block></v-text-field>
                                            <v-btn height="40" class="bg-main text-white mt-3" @click="search(0)"><v-icon>mdi-magnify</v-icon></v-btn>
                                        </v-row> -->
    
                            <!-- <v-row v-if="errMsg != null" class="mt-5">
                                            <span class="col-12 display-1 text-left">{{errMsg}}</span>
                                        </v-row> -->
    
                            <v-row v-if="feeds != null && feeds.length == 0" class="mt-5">
                                <span class="col-12 display-1 text-left">업로드된 피드가 없습니다.</span>
                            </v-row>
    
                            <v-row class="mt-5">
                                <v-col cols="12" md="4" v-for="(feed, index) in feeds">
                                    <v-card height="450" outlined elevation="5" class="">
                                        <v-img height="200" width="100%" :src="feed.feedPreviewImgUrl"></v-img>
                                        <v-card-title>{{feed.feedName}}</v-card-title>
                                        <v-card-subtitle class="text-left mt-2 pb-0">공고기관: {{feed.feedHost}}</v-card-subtitle>
                                        <v-card-subtitle class="text-left">피드주소: <a :href="feed.feedUrl" target="_blank">{{feed.feedUrl}}</a></v-card-subtitle>
                                        <v-dialog v-model="adminDeleteDialog[index]" max-width="290">
                                            <template v-slot:activator="{ on }">
                                                <v-row>
                                                    <v-btn class="bg-main text-white border-rounded30 mx-auto" style="inline-block" :height="30" v-on="on">
                                                        <span>삭제</span>
                                                    </v-btn>
                                                </v-row>
                                            </template>
                                            <v-card>
                                                    <v-card-title>주의</v-card-title>
                                                    <v-card-text>
                                                        <span class="mt-5">정말 삭제하시겠습니까?</span>
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="text-main" text @click="adminDelete(feed.feedIdx, feed.categoryIdx)">예</v-btn>
                                                        <v-btn color="text-grey-1" text @click="adminDeleteDialog.splice(index, 1, false)">아니요</v-btn>
                                                    </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-card>
                                </v-col>


                            </v-row>
                            <v-row v-if="tableInfo" class="mt-5 mb-5">
                                <v-col cols="12" class="text-center">
                                    <v-btn v-if="tableInfo.curSet > 1" class="bg-main text-white mt-1" @click="getSetPageHref(-1)"><v-icon>mdi-chevron-left</v-icon></v-btn>
                                    <v-btn v-for="pageNum in pageList" :class="cur == pageNum ? 'mx-1 mt-1 blue darken-2 text-white' : 'mx-1 mt-1 white text-black'" elevation="5" @click="getPageHref(pageNum)">{{pageNum}}</v-btn>
                                    <v-btn v-if="tableInfo.curSet < tableInfo.totalSet" class="bg-main text-white mt-1" @click="getSetPageHref(1)"><v-icon>mdi-chevron-right</v-icon></v-btn>
                                </v-col>
                                
                            </v-row>
                        </v-container>

                        <v-container v-else-if="userinfo.authAdmin != 2" fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">권한이 없습니다. 로그인 해주세요.</span>
                            </v-row>
                        </v-container>

                        <v-container v-else fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">로딩중...</span>
                            </v-row>
                        </v-container>
                        <Footer></Footer>
                    </v-flex>
                </v-layout>
    
            </v-container>

    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()

        this.cur = this.$route.query.cur
        this.category = this.$route.query.category
        if (this.cur == null) this.cur = 1
        else {
            if (this.cur < 1) this.cur = 1
        }
        if (this.category == null) {
            this.tab = 0
        } else {
            this.tab = Number(this.category) - 100
        }
        this.getFeeds()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 2,
            window: {
                width: 0,
                height: 0
            },
            ismobile: false,
            drawer: false,
            group: null,

            feeds: [],
            cur: 1,
            category: null,
            tableInfo: null,

            feedName: '',
            feedHost: '',
            feedUrl: '',
            feedPreviewImgUrl: '',
            categoryIdx: 101,
            pageList: [],

            isUploaded: false,
            tab: null,
            items: [
                { tab: '전체', href: '/admin/feeds?cur=1' },
                { tab: '대학생활', href: '/admin/feeds?cur=1&category=101' },
                { tab: '취업뉴스', href: '/admin/feeds?cur=1&category=102' },
                { tab: '시사상식', href: '/admin/feeds?cur=1&category=103' },
                { tab: '금융상식', href: '/admin/feeds?cur=1&category=104' },
                { tab: '디자인', href: '/admin/feeds?cur=1&category=105' },
                { tab: '기타', href: '/admin/feeds?cur=1&category=106' },
            ],

            adminDeleteDialog: [],
            // pageList: function(){
            //     var list = []
            //     for(var i = this.tableInfo.startPage; i <= this.tableInfo.endPage; i++){
            //         list.push(i)
            //     }
            //     return list
            // }

        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        },
        registerFeed() {
            if (this.feedName.trim() == '') {
                alert('피드 제목을 입력해주세요.')
            } else if (this.feedHost.trim() == '') {
                alert('피드 공고기관을 입력해주세요.')
            } else if (this.feedUrl.trim() == '') {
                alert('피드 주소를 입력해주세요.')
            } else {
                this.$http.post('/api/feeds', {
                        headers: { 'Content-type': 'application/x-www-form-urlencoded', },
                        feedName: this.feedName,
                        feedHost: this.feedHost,
                        feedUrl: this.feedUrl,
                        feedPreviewImgUrl: this.feedPreviewImgUrl,
                        categoryIdx: this.categoryIdx
                    })
                    .then(response => {
                        if (response.data.status == 200) {
                            if (this.category == null) {
                                window.location.href = '/admin/feeds?cur=' + this.cur
                            } else {
                                window.location.href = '/admin/feeds?cur=' + this.cur + '&category=' + this.category
                            }
                            alert('피드 등록 완료')
                        } else {
                            alert('피드 등록 실패')
                        }
                    })
                    .catch(error => {
                        console.log('register failed', error)
                    })
            }
        },
        adminDelete(feedIdx, categoryIdx) {
            this.$http.delete('/api/feeds/' + feedIdx + '?categoryIdx=' + categoryIdx)
                .then((response) => {
                    if (response.data.status == 200) {
                        alert('삭제 완료')
                        if (this.category == null) {
                            window.location.href = '/admin/feeds?cur=' + this.cur
                        } else {
                            window.location.href = '/admin/feeds?cur=' + this.cur + '&category=' + this.category
                        }
                        console.log(response)
                    } else {
                        alert('delete fail: ' + posterIdx)
                        console.log(response)
                    }
                })
        },
        upload() {
            if (this.file == null) {
                alert('사진을 등록해주세요')
                return
            }
            var fd = new FormData()
            fd.append('imgFile', this.file, 'filename.jpg')

            this.$http.post(`/api/photos/reg`, fd)
                .then((response) => {
                    if (response.data.status == 200) {
                        console.log(response.data.data);
                        this.feedPreviewImgUrl = response.data.data.photoUrl.original
                        this.isUploaded = true
                        alert('업로드 완료!')
                    } else {
                        alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                        this.$store.dispatch('postLogout')
                    }
                }).catch(error => {
                    console.log(error)
                })
        },
        uploadInit() {
            this.feedPreviewImgUrl = '',
                this.isUploaded = false
        },
        getFeeds() {
            let queryString = '';
            queryString += 'cur=' + this.cur
            if (this.category != null) queryString += '&category=' + this.category
            this.$http.get('/api/feeds?' + queryString)
                .then((response) => {
                    console.log(response)
                    if (response.data.status == 200) {
                        console.log(response.data)
                        this.feeds = response.data.data.feeds
                        this.tableInfo = response.data.data.tableInfo
                        this.pageList = []
                        for (var i = this.tableInfo.startPage; i <= this.tableInfo.endPage; i++) {
                            this.pageList.push(i)
                        }
                        this.adminDeleteDialog = []
                        for(var i = 0; i < this.feeds.length; i++){
                            this.adminDeleteDialog.push(false)
                        }
                    } else {
                        alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                        this.$store.dispatch('postLogout')
                    }
                })
        },
        getPageHref(page) {
            this.cur = page
            this.getFeeds()
        },
        getSetPageHref(next) {
            let firstPage = (Math.ceil(this.cur / 10) - 1) * 10 + 1
            let nextPage;
            if (next == -1) {
                nextPage = firstPage - 1
            } else {
                nextPage = firstPage + 10
            }
            this.cur = nextPage
            this.getFeeds()
        },
        goCategory(href) {
            window.location.href = href
        },
    }
}
</script>

<style lang="css">

</style>


// WEBPACK FOOTER //
// src/pages/AllFeeds.vue